import { AxiosInstance } from 'axios';
import {
  AddDefaultContactsResponse,
  BulkAddContactsRequest,
  ContactList,
  ContactListCreateRequest,
  ContactListUpdateRequest,
} from '@/api/contact-list/contact-list.types.ts';

export const createContactListsApi = (api: AxiosInstance) => ({
  getContactLists: () => api.get<ContactList[]>('/v1/contact-lists'),

  getContactList: (listId: number) =>
    api.get<ContactList>(`/v1/contact-lists/${listId}`),

  createContactList: (body: ContactListCreateRequest) =>
    api.post<ContactList>('/v1/contact-lists', body),

  updateContactList: (listId: number, body: ContactListUpdateRequest) =>
    api.patch<ContactList>(`/v1/contact-lists/${listId}`, body),

  deleteContactList: (listId: number) =>
    api.delete<void>(`/v1/contact-lists/${listId}`),

  addDefaultContacts: (listId: number, scope: 'own' | 'all' = 'own') =>
    api.post<AddDefaultContactsResponse>(
      `/v1/contact-lists/${listId}/add-default-contacts`,
      undefined,
      { params: { scope } },
    ),

  bulkAddContacts: (listId: number, body: BulkAddContactsRequest) =>
    api.post<AddDefaultContactsResponse>(
      `/v1/contact-lists/${listId}/bulk-add-contacts`,
      body,
    ),
});
